import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Cell, Row, H5, Subheading } from '@fs/zion-ui'
import { useRouteMatch } from '@fs/zion-router'
import { isNullOrUndefinedOrEmpty } from '../../../../util/Utils'
import { deleteLastPathElement } from '../../../../util/UrlUtil'
import TopOperations from '../TopOperations'

export default function CompactMessagesTableInfo({ queueState, queueActions }) {
  const { t } = useTranslation()
  const match = useRouteMatch()

  return (
    <Row>
      <Cell columns={7}>
        <H5 supplementary>
          <Row alignY="middle">
            <span>{queueState.queueName}</span>
            <Button to={deleteLastPathElement(match.url)}>{t('queues.backToQueueList', 'Back to Queue List')}</Button>
          </Row>
          <Subheading>{`${queueState.queueType} (${queueState.queueContents.length} ${t('queues.from', 'from')} ${
            queueState.queueTotal
          })`}</Subheading>
        </H5>
      </Cell>
      <div growX />
      <Cell columns={5}>
        <TopOperations
          queueState={queueState}
          queueActions={queueActions}
          disabled={isNullOrUndefinedOrEmpty(queueState.selectedCheckboxes)}
        />
      </Cell>
    </Row>
  )
}
